export enum TipusPartidaEcom {
  AJUSTOS = "ajustos",
  DADES_ECONOMIQUES = "dadesEconomiques"
}
